/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./product-view-graphics";
import * as i2 from "ionic-angular/navigation/nav-controller";
import * as i3 from "ionic-angular/navigation/nav-params";
var styles_ProductViewGraphicsPage = [];
var RenderType_ProductViewGraphicsPage = i0.ɵcrt({ encapsulation: 2, styles: styles_ProductViewGraphicsPage, data: {} });
export { RenderType_ProductViewGraphicsPage as RenderType_ProductViewGraphicsPage };
export function View_ProductViewGraphicsPage_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 0, "div", [["class", "row"]], null, null, null, null, null))], null, null); }
export function View_ProductViewGraphicsPage_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "page-product-view-graphics", [], null, null, null, View_ProductViewGraphicsPage_0, RenderType_ProductViewGraphicsPage)), i0.ɵdid(1, 49152, null, 0, i1.ProductViewGraphicsPage, [i2.NavController, i3.NavParams], null, null)], null, null); }
var ProductViewGraphicsPageNgFactory = i0.ɵccf("page-product-view-graphics", i1.ProductViewGraphicsPage, View_ProductViewGraphicsPage_Host_0, { product: "product" }, {}, []);
export { ProductViewGraphicsPageNgFactory as ProductViewGraphicsPageNgFactory };
//# sourceMappingURL=product-view-graphics.ngfactory.js.map


//////////////////
// WEBPACK FOOTER
// ./src/pages/products/product-view/product-view-graphics/product-view-graphics.ngfactory.js
// module id = null
// module chunks = 